<template>
  <el-dialog
    :title="
      '版本对比（最新版本:' +
      $common.formatTimesToTime(currentCompareVersion.created_at) +
      '）'
    "
    :visible.sync="visible.show"
    width="80%"
  >
    <div>
      <div style="padding-top: 10px">
        <el-form :inline="true" :model="form">
          <el-form-item label="左边版本:" style="text-align: left">
            <el-select v-model="form.version">
              <el-option
                v-for="(item, index) in resetVersionList"
                :key="index"
                :value="item.id"
                :label="$common.formatTimesToTime(item.created_at)"
                :disabled="item.id === form.compareVersion"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="右边版本:"
            style="text-align: left; margin-left: 8px"
          >
            <el-select v-model="form.compareVersion">
              <el-option
                v-for="(item, index) in resetVersionList"
                :key="index"
                :value="item.id"
                :label="$common.formatTimesToTime(item.created_at)"
                :disabled="item.id === form.version"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <HistoryCompare
        :version="currentVersion"
        :compareVersion="currentCompareVersion"
      />
    </div>
  </el-dialog>
</template>

<script>
import HistoryCompare from "./historyCompare.vue";

export default {
  props: {
    versionList: {
      type: Array,
      default: () => [],
    },
    visible: {
      default: () => ({
        show: false,
      }),
    },
    version: {
      type: String,
    },
  },
  data() {
    return {
      form: {
        version: "",
        compareVersion: "",
      },
      resetVersionList: [],
    };
  },
  computed: {
    currentVersion() {
      return this.resetVersionList.find(
        (item) => item.id === this.form.version
      );
    },
    currentCompareVersion() {
      return this.resetVersionList.find(
        (item) => item.id === this.form.compareVersion
      );
    },
  },
  watch: {
    versionList: {
      handler(newVal) {
        const value = (newVal || []).slice(0);
        this.resetVersionList = value;
        this.form.compareVersion = (value[value.length - 1] || {}).id;
      },
      deep: true,
      immediate: true,
    },
    version: {
      handler(newVal) {
        this.form.version = newVal;
      },
      immediate: true,
    },
  },
  components: {
    HistoryCompare,
  },
};
</script>

<style lang="">
</style>